package com.siriusxm.pia.components

import androidx.compose.runtime.*
import com.siriusxm.cmc.utils.Navigator
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.events.Event

data class NavigationItem(
    val name: String,
    val path: String,
    val onClick: (() -> Unit)? = null
)

/**
 * Initialize a nav bar with a provided navigator, which will handle the clicks and url resolution.
 */
fun ServiceViewConfiguration.simpleNavSidebar(
    navigator: Navigator,
    initVisible: Boolean,
    title: String,
    elements: List<NavigationItem>
) {
    val mapped = elements.map {
        it.copy(
            onClick = it.onClick ?: {
                navigator.navigate(it.path)
            }
        )
    }
    simpleNavSidebar(initVisible, title, mapped)
}

/**
 * Renders a simple navigation sidebar element with a title that listens to browser location changes
 */
fun ServiceViewConfiguration.simpleNavSidebar(
    initVisible: Boolean,
    title: String,
    elements: List<NavigationItem>,
    autoHide: Boolean = false
) {
    navigationSidebar(initVisible, title) {
        var currentPath by remember { mutableStateOf(window.location.hash) }

        // Listen to browser location changes
        DisposableEffect(Unit) {
            val listener: (Event) -> Unit = {
                currentPath = window.location.hash
            }
            window.addEventListener("hashchange", listener)

            // Cleanup listener on disposal
            onDispose {
                window.removeEventListener("hashchange", listener)
            }
        }

        val pathWithoutPrefix = currentPath.removePrefix("#")

        // Kind of an unusual way to find the selection. We look for the longest path
        // that matches the current path.
        var seletedItem: NavigationItem? = null
        elements.forEach { navItem ->
            if (pathWithoutPrefix.startsWith(navItem.path)) {
                if (seletedItem == null || seletedItem.path.length < navItem.path.length) {
                    seletedItem = navItem
                }
            }
        }


        Div({
            classes(ServiceViewStyles.simpleNavContainer)
        }) {
            Ul({
                classes(ServiceViewStyles.simpleNavList)
            }) {
                elements.forEach { navItem ->
                    Li({
                        classes(ServiceViewStyles.simpleNavListItem)
                        if (seletedItem == navItem) {
                            classes(ServiceViewStyles.simpleNavSelected)
                        }
                    }) {
                        A(href = "/#${navItem.path}", {
                            this.onClick {
                                if (autoHide) {
                                    hideSidebar()
                                }
                                if (navItem.onClick != null) {
                                    navItem.onClick()
                                    it.preventDefault()
                                }
                            }
                        }) {
                            Text(navItem.name)
                        }
                    }
                }
            }
        }
    }
}
